import React from 'react'
import styled from '@emotion/styled'
import Select from 'react-select'

import GroupService from 'Services/groups'

const SelectGroup = styled(Select)`
  width: 100%;
`

export const groupOptions = async appCodes => {
  const groups = await GroupService.list({ appCodes })

  const allOptions = groups.map(group => {
    return {
      value: group,
      label: group
    }
  })

  if (allOptions.length > 0) {
    // add none option
    allOptions.unshift({ value: 'None', label: 'None' })
  }

  return allOptions
}

export default React.memo(({ ...props }) => {
  return <SelectGroup {...props} />
})
